import React from "react";
import propTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({
  component,
  exact = false,
  path,
  token
}) => {
  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => {
        return token ? (
          React.createElement(component, props)
        ) : (
          <Redirect to={`/login`} />
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: propTypes.oneOfType([propTypes.object, propTypes.func]).isRequired,
  exact: propTypes.bool,
  path: propTypes.oneOfType([
    propTypes.object,
    propTypes.array,
    propTypes.string,
  ]).isRequired,
  location: propTypes.object,
};

export default PrivateRoute;
